import type { PdfFile, PdfLink } from '~/sanity/types';

/** The resolved file may come from a translation entry or the default file. */
type ResolvedPdfFile = PdfFile | NonNullable<PdfLink['pdfFile']>;

/**
 * Picks the translated PDF file whose language matches the current site locale,
 * falling back to the default file when no translation matches.
 */
export const resolveTranslatedPdfFile = ({
  pdfLink,
  lang,
}: {
  pdfLink: Pick<PdfLink, 'pdfFile' | 'translations'>;
  lang: string;
}): ResolvedPdfFile | undefined => {
  const match = pdfLink.translations?.find((entry) => entry?.language === lang);
  return match?.pdfFile ?? pdfLink.pdfFile;
};

/**
 * Builds the `/cdn-files/...` URL from a Sanity file asset `_ref`, or returns
 * `undefined` when the ref is missing or malformed.
 */
export const cdnFileSrcFromAssetRef = (assetRef: string | undefined): string | undefined => {
  if (!assetRef) {
    return undefined;
  }
  const bits = assetRef.split('-');
  if (bits.length < 3) {
    return undefined;
  }
  const fileName = bits[1];
  const fileExtension = bits[2];
  return `/cdn-files/${fileName}.${fileExtension}`;
};
